module.exports = __webpack_public_path__ + "static/media/happy.f2a1e86e.png";